module.exports = __webpack_public_path__ + "static/media/DAR.5c7bc908.svg";